// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-comment .user-info-container {
   justify-content: flex-start;
}

.add-comment .user-info-container {
   align-self: flex-start;
}

.add-comment form {
   width: 100%;
}

.add-comment-container {
   display: flex;
   flex-wrap: wrap;
}

.add-comment .button-container {
   text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLComments/ECLAddComment/ECLAddComment.css"],"names":[],"mappings":"AAAA;GACG,2BAA2B;AAC9B;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,aAAa;GACb,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB","sourcesContent":[".add-comment .user-info-container {\r\n   justify-content: flex-start;\r\n}\r\n\r\n.add-comment .user-info-container {\r\n   align-self: flex-start;\r\n}\r\n\r\n.add-comment form {\r\n   width: 100%;\r\n}\r\n\r\n.add-comment-container {\r\n   display: flex;\r\n   flex-wrap: wrap;\r\n}\r\n\r\n.add-comment .button-container {\r\n   text-align: right;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
